import { FC } from 'react'
import { UserType } from '../types'

interface UserCardProps {
  user: UserType
  onEditPermissions: (user: UserType) => void
}

export const UserCard: FC<UserCardProps> = ({ user, onEditPermissions }) => {
  const getStatusColor = (status: boolean) => {
    return status ? 'success' : 'danger'
  }

  const getStatusText = (status: boolean) => {
    return status ? 'Ativo' : 'Inativo'
  }

  return (
    <div className='card h-100 shadow-sm'>
      <div className='card-header bg-light d-flex justify-content-between align-items-start'>
        <div className='flex-shrink-0'>
          {user.image ? (
            <img
              src={user.image}
              alt={user.name}
              className='rounded-circle'
              width='60'
              height='60'
              style={{ objectFit: 'cover' }}
            />
          ) : (
            <div
              className='rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold'
              style={{ width: '60px', height: '60px', fontSize: '1.5rem' }}
            >
              {user.name.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        <span className={`badge bg-${getStatusColor(user.status)}`}>
          {getStatusText(user.status)}
        </span>
      </div>

      <div className='card-body d-flex flex-column'>
        <h5 className='card-title'>{user.name}</h5>
        <p className='card-text text-muted small'>{user.email}</p>

        <div className='small'>
          <div className='mb-2'>
            <span className='text-muted'>Tipo:</span>
            <span className='fw-bold ms-2'>{user.type}</span>
          </div>
          <div className='mb-2'>
            <span className='text-muted'>CPF:</span>
            <span className='fw-bold ms-2'>{user.cpf}</span>
          </div>
          <div>
            <span className='text-muted'>Data:</span>
            <span className='fw-bold ms-2'>
              {new Date(user.created).toLocaleDateString('pt-BR')}
            </span>
          </div>
        </div>
      </div>

      <div className='card-footer bg-white border-top'>
        <button
          className='btn btn-primary btn-sm w-100'
          onClick={() => onEditPermissions(user)}
        >
          <i className='fas fa-lock me-2'></i>Gerenciar Permissões
        </button>
      </div>
    </div>
  )
}
